// generate by script, don't edit it.
import React from 'react';
import SvgBase from '../SvgBase';
import { IProps } from '../SvgBase/types';
export const RingPointer: React.FC<IProps> = (props: IProps) => {
    const { sx: propSx = {}, ...restProps } = props;
    return (<SvgBase  xmlns="http://www.w3.org/2000/svg" width="26" height="35" viewBox="0 0 26 35" fill="none" sx={propSx}  {...restProps} iconName="i-ring-pointer"><g clipPath="url(#clip0_5473_2217)"><path opacity="0.8" d="M13.3422 34.2V9.0054L0.742188 0L13.3422 34.2Z" fill="#EAECEF" /><path d="M13.3423 34.2V9.0054L25.9423 0L13.3423 34.2Z" fill="#EAECEF" /></g><defs><clipPath id="clip0_5473_2217"><rect width="25.2" height="34.2" fill="white" transform="translate(0.742188)" /></clipPath></defs></SvgBase>);
};
const MemoRingPointer = React.memo(RingPointer);
MemoRingPointer.displayName = 'RingPointer';
export default MemoRingPointer;